import DotIcon from "@mui/icons-material/FiberManualRecord";
import { useNotifications } from "features/Notifications/useNotifications";
import { memo } from "react";

export const NotificationDot = memo(
  ({
    id,
    mode,
    translate = { x: 0, y: 2 },
  }: {
    id: string;
    mode: "parent" | "self" | "either";
    translate?: { x: number; y: number };
  }) => {
    const {
      hasUnreadNotification,
      shouldEntityHaveNotificationDotById,
      hasUnreadNotificationChildren,
    } = useNotifications();
    let shouldShowDot = false;
    if (mode === "parent") {
      shouldShowDot = hasUnreadNotificationChildren(id);
    } else if (mode === "self") {
      shouldShowDot = hasUnreadNotification(id);
    } else if (mode === "either") {
      shouldShowDot = shouldEntityHaveNotificationDotById(id);
    }
    if (!shouldShowDot) {
      return null;
    }
    return (
      <DotIcon
        sx={{ translate: `${translate.x}px ${translate.y}px` }}
        color="secondary"
        fontSize="inherit"
      />
    );
  }
);
NotificationDot.displayName = "NotificationDot";
